export const FOUNDATION_ID = "rarpg:browser-foundation";

export * from "./ability-runtime-contracts";
export {
  ABILITY_DAMAGE_EXECUTOR_ID,
  BASIC_CLEAVE_ID,
  CINDER_DART_ID,
  COMBAT_ABILITY_DEFINITIONS,
  DEFIANT_SIGNAL_ID,
  MANA_RESOURCE_ID,
  MOVE_SPEED_STAT_ID,
  OUTGOING_DAMAGE_STAT_ID,
  RefreshingStatusStore,
  WINTER_PULSE_ID,
  damageAfterModifier,
  definitionById,
  pointInArea,
  sweptCircleHitFraction,
  targetMatches,
  type CombatAbilityId,
  type CombatAbilityDefinition,
  type CombatAbilityEffect,
  type CombatEffectParameter,
  type CombatEffectParameters,
  type CombatStatusId,
  type StatusInstance,
} from "./combat-abilities";
export {
  CombatArenaSimulation,
  DEFAULT_COMBAT_ARENA_CONFIG,
  type AttackPhase,
  type CombatArenaConfig,
  type CombatArenaDiagnostics,
  type CombatArenaEvent,
  type CombatArenaEventReader,
  type CombatAbilityActivationKind,
  type CombatAbilityActivationReadModel,
  type CombatAreaFeedbackReadModel,
  type CombatProjectileReadModel,
  type CombatSlotRequestResult,
  type CombatTargetReadModel,
  type MinimapBoundsReadModel,
  type MinimapMarkerKind,
  type MinimapMarkerReadModel,
  type MinimapReadModel,
  type CharacterCombatStats,
  type CharacterItemLoadoutReadModel,
  type CraftFailure,
  type CraftResult,
  type GatheringReadModel,
  type InteractFailure,
  type FlaskDrinkFailure,
  type FlaskDrinkResult,
  type FlaskRecoveryDiagnostics,
  type FlaskSlotDiagnostics,
  type InteractResult,
  type LootPickupFailure,
  type LootPickupResult,
  type QuestReadModel,
  type RespawnResult,
  type TravelFailure,
  type TravelResult,
  type VendorTradeFailure,
  type VendorTradeResult,
  type WorldInteractableReadModel,
} from "./combat-arena";
export {
  GOLD_MAX_TOTAL,
  STARTING_GOLD,
  parseCharacterSave,
  type CharacterSave,
  type CharacterSaveGenerators,
} from "./character-save";
export { displayedTotalDps } from "./combat-power";
export {
  HIGHSCORE_LIMIT,
  rankHighscores,
  type HighscoreCandidate,
  type HighscoreRow,
} from "./highscores";
export {
  FLASK_BASE_CHARGES_GAINED_ON_KILL,
  FLASK_DRINK_SHARED_COOLDOWN_TICKS,
  FLASK_MINIMUM_CHARGES_USED,
  flaskEffectiveStats,
  flaskResourceOf,
  type FlaskEffectiveStats,
  type FlaskResource,
} from "./flasks";
export {
  HealthPool,
  type Damageable,
  type DamageIgnoreReason,
  type DamageRequest,
  type DamageResult,
  type HealthReadModel,
} from "./health";
export {
  ABILITY_STONE_BASE_ID,
  AFFIX_CATALOG,
  AFFIX_TIER_COUNT,
  ALL_EQUIPMENT_BASES,
  CRAFTED_BASE_CATALOG,
  EQUIPMENT_BASE_CATALOG,
  EQUIPMENT_SLOTS,
  FLASK_BASE_CATALOG,
  FLASK_SLOTS,
  IMPLEMENTED_ABILITY_CATALOG,
  ITEM_BASE_CATALOG,
  MAXIMUM_HEALTH_STAT_ID,
  affixById,
  equipmentBaseById,
  formatItemModifierLabel,
  isAffixLegalForBase,
  isFlaskSlot,
  slotAcceptsKind,
  slotsForKind,
  type AffixDefinition,
  type AffixModifierDefinition,
  type AffixTierRange,
  type AffixTierRanges,
  type EquipmentBaseDefinition,
  type EquipmentSlot,
  type EquipmentSlotKind,
  type FlaskSlot,
  type GeneratableItemRarity,
  type ItemRarity,
  type ItemStatModifier,
  type MaximumHealthModifier,
  type OutgoingAbilityDamageModifier,
  type WearableSlot,
} from "./item-catalog";
export {
  AFFIX_COUNTS_BY_RARITY,
  AFFIX_TIER_WEIGHTS,
  createAbilityStoneStack,
  createMaterialStack,
  equipmentSlotKindOf,
  REQUIRED_LEVEL_BY_RARITY,
  generateEquipmentItem,
  modifiersForEquipment,
  requiredLevelForRarity,
  type AbilityStoneStack,
  type AffixCountRange,
  type EquipmentItemInstance,
  type GenerateEquipmentItemOptions,
  type ItemInstance,
  type MaterialStack,
  type RolledAffix,
} from "./item-generation";
export {
  CharacterItemLoadout,
  DEFAULT_BASE_CHARACTER_STATS,
  LOADOUT_SLOTS,
  aggregateEquipmentStats,
  applyOutgoingAbilityDamage,
  type BaseCharacterStats,
  type CharacterItemsSnapshot,
  type EquipmentStats,
  type EquipFailure,
  type EquipResult,
  type LoadoutAssignmentFailure,
  type LoadoutAssignmentResult,
  type LoadoutSlot,
  type StoneConsumptionFailure,
  type StoneConsumptionResult,
} from "./item-loadout";
export {
  ABILITY_STONE_STACK_LIMIT,
  INVENTORY_SLOT_COUNT,
  Inventory,
  type InventoryAddFailure,
  type InventoryAddResult,
} from "./inventory";
export {
  ATTRIBUTE_IDS,
  ATTRIBUTE_LABELS,
  ATTRIBUTE_POINTS_PER_LEVEL,
  ATTRIBUTE_SUMMARIES,
  BASE_MAXIMUM_MANA,
  BASE_MOVE_SPEED_BASIS_POINTS,
  CharacterProgression,
  DEXTERITY_MOVE_SPEED_BASIS_POINTS,
  ENEMY_KILL_EXPERIENCE,
  INTELLIGENCE_MAXIMUM_MANA,
  PASSIVE_CATALOG,
  PASSIVE_POINTS_PER_LEVEL,
  STARTING_ATTRIBUTE_POINTS,
  STARTING_LEVEL,
  STARTING_PASSIVE_POINTS,
  STRENGTH_DAMAGE_BASIS_POINTS,
  VITALITY_MAXIMUM_HEALTH,
  experienceToNextLevel,
  passiveById,
  type AttributeId,
  type AttributeReadModel,
  type CharacterProgressionReadModel,
  type CharacterProgressionSnapshot,
  type ExperienceGrantResult,
  type PassiveDefinition,
  type PassiveReadModel,
  type ProgressionBonuses,
  type ProgressionSpendFailure,
  type ProgressionSpendResult,
} from "./progression";
export {
  ARENA_FORGE,
  ARENA_FORGE_ID,
  CRAFTING_RECIPE_CATALOG,
  DEEPVEIN_CLEAVER_RECIPE_ID,
  DEEPVEIN_ORE_ID,
  DEEPVEIN_SEAM_ID,
  INTERACT_RADIUS,
  MATERIAL_CATALOG,
  MATERIAL_STACK_LIMIT,
  ORE_NODE_CATALOG,
  PROFESSION_IDS,
  PROFESSION_LABELS,
  ProfessionProgression,
  TEMPERING_CLEAVER_RECIPE_ID,
  TEMPERING_VEST_RECIPE_ID,
  VEINSHARD_ORE_ID,
  VEINSHARD_OUTCROP_ID,
  materialById,
  oreNodeById,
  professionExperienceToNextLevel,
  recipeById,
  type CraftingIngredient,
  type CraftingRecipeDefinition,
  type ForgeDefinition,
  type MaterialDefinition,
  type OreNodeDefinition,
  type ProfessionGrantResult,
  type ProfessionId,
  type ProfessionProgressionSnapshot,
  type ProfessionReadModel,
  type WorldInteractableKind,
} from "./professions";
export {
  ASHTRAIL_BRUTE,
  ASHTRAIL_BRUTE_ID,
  ASHTRAIL_ENEMY,
  ASHTRAIL_EXPANSE_ID,
  ASHTRAIL_PACK,
  BOSS_KILL_EXPERIENCE,
  ELITE_KILL_EXPERIENCE,
  EMBERCLEFT,
  EMBERCLEFT_ID,
  HEARTHMERE_FORGE,
  HEARTHMERE_ID,
  HOLLOWDEEP_BRUISER,
  HOLLOWDEEP_BRUISER_ID,
  HOLLOWDEEP_CULLING_QUEST,
  HOLLOWDEEP_CULLING_QUEST_ID,
  HOLLOWDEEP_ID,
  ROADWARDEN,
  ROADWARDEN_ID,
  WAKESHORE_LANDING_ID,
  WAKESHORE_SCUTTLER,
  WAKESHORE_SCUTTLER_ID,
  WAKESHORE_VEINSHARD_NODE,
  WAKESHORE_VEINSHARD_NODE_ID,
  WICK_PROVISIONS,
  WICK_PROVISIONS_ID,
  WICK_TRAIL_VEST_OFFER_ID,
  ZONE_CATALOG,
  ZONE_IDS,
  isZoneId,
  loginSpawnZoneId,
  vendorOfferById,
  zoneById,
  zoneEnemies,
  type PortalDefinition,
  type QuestDefinition,
  type QuestGiverDefinition,
  type QuestStage,
  type VendorDefinition,
  type VendorOfferDefinition,
  type ZoneDefinition,
  type ZoneId,
  type ZoneKind,
} from "./world-zones";
export {
  DEFAULT_ENEMY_LOOT_WEIGHTS,
  DeterministicEnemyLootGenerator,
  GOLD_DROP_RANGES,
  goldSeedFromRunSeed,
  type EnemyLootGeneratorConfig,
  type EnemyLootGeneratorSnapshot,
  type EnemyLootWeights,
  type GeneratedEnemyLoot,
  type GoldPileDrop,
  type WorldLootDrop,
} from "./enemy-loot";
export {
  TUTORIAL_STEP_IDS,
  TUTORIAL_STEPS,
  TutorialTracker,
  type TutorialReadModel,
  type TutorialStepDefinition,
  type TutorialStepId,
} from "./tutorial";
export {
  SimpleMeleeEnemy,
  type EnemyRank,
  type MeleeEnemyState,
  type MeleeEnemyTarget,
  type PlayerDamageApplicator,
  type SimpleMeleeEnemyConfig,
  type SimpleMeleeEnemyDiagnostics,
} from "./simple-melee-enemy";
export {
  AbilityExecutionEngine,
  type AbilityExecutionDependencies,
} from "./ability-runtime";
export {
  CHARACTER_NAME_PATTERN,
  CHARACTER_NAME_RULE_MESSAGE,
  CHARACTER_SLOT_LIMIT,
  normalizeCharacterName,
} from "./character-identity";
export type { Clock } from "./clock";
export {
  createCoreRuntime,
  type CoreDependencies,
  type CoreRuntime,
  type SimulationStepContext,
  type SimulationSystem,
} from "./composition";
export {
  FIXED_STEP_MILLISECONDS,
  FIXED_STEP_SECONDS,
  FIXED_TICKS_PER_SECOND,
  FixedStepRunner,
  type AdvanceResult,
  type FixedStep,
  type FixedStepCallback,
  type FixedStepRunnerOptions,
} from "./fixed-step";
export {
  contentId,
  persistentInstanceId,
  SequentialRuntimeEntityIds,
  type ContentId,
  type PersistentInstanceId,
  type RuntimeEntityId,
  type RuntimeEntityIdSource,
} from "./ids";
export {
  PresentationComponentStore,
  PresentationKind,
  TECHNICAL_UPDATE_ORDER,
  TechnicalEntityLifecycle,
  TransformComponentStore,
  type EntityLifecycleDiagnostics,
  type TechnicalUpdateStage,
  type TransformWrite,
} from "./entity-lifecycle";
export type {
  CommandEnvelope,
  CommandSource,
  CommandsFrom,
  EventEnvelope,
  EventSink,
  EventsFrom,
} from "./messages";
export type { IntentSink, ReadModelSource } from "./ui-boundary";
export {
  MULBERRY32_ALGORITHM,
  Mulberry32,
  type RandomSource,
  type RandomState,
  type StatefulRandomSource,
} from "./random";
export {
  BLOCKED_NAVIGATION_COST,
  MAXIMUM_NAVIGATION_COST,
  MINIMUM_NAVIGATION_COST,
  NavigationGrid,
  type CompiledNavigationGridData,
  type GridPoint,
} from "./navigation-grid";
export {
  BoundedAStar,
  createPathResult,
  PathBuffer,
  type PathResult,
  type PathStatus,
} from "./pathfinding";
export {
  FairPathRequestScheduler,
  type PathCompletionSink,
  type PathRequest,
  type PathRequestRejection,
  type PathSchedulerOptions,
  type PathSchedulerTickResult,
} from "./path-scheduler";
export { computeLocalSeparation, type MutableVector2 } from "./separation";
export {
  aabbsOverlap,
  circleIntersectsAabb,
  circlesOverlap,
  segmentIntersectsAabb,
  segmentIntersectsCircle,
  SpatialQueryBuffer,
  UniformSpatialHash,
  type Aabb,
  type Circle,
  type MutableCircleQuery,
  type MutableSegmentQuery,
  type Point2,
  type Segment,
  type SpatialAllocationDiagnostics,
  type SpatialRecord,
} from "./spatial";
export {
  FIXTURE_STAGE_SAMPLE_CAPACITY,
  SYNTHETIC_ACTOR_COUNT,
  SYNTHETIC_CAMERA_HEIGHT,
  SYNTHETIC_CAMERA_WIDTH,
  SYNTHETIC_ENTITY_COUNT,
  SYNTHETIC_FIXTURE_SCHEMA,
  SYNTHETIC_FIXTURE_SEED,
  SYNTHETIC_LOOT_COUNT,
  SYNTHETIC_PARTICLE_COUNT,
  SYNTHETIC_PROJECTILE_COUNT,
  SYNTHETIC_WORLD_SIZE,
  SyntheticLifecycleFixture,
  type FixturePathDiagnostics,
  type FixtureStageSampleSummary,
  type FixtureStageTimings,
  type FixtureTimer,
  type RawFixtureStageSamples,
  type SyntheticFixtureDiagnostics,
  type TimingSampleSummary,
} from "./synthetic-lifecycle-fixture";
